import { normalizeClassification } from "@serendiptv/contracts";
import type { FaceMetadata, SelectionResponse } from "../types";

const ERA_LABELS = ["1950s", "1960s", "1970s", "1980s", "1990s", "2000s"];

export function deriveEra(year: number | null | undefined): string | null {
  if (!year || !Number.isFinite(year)) return null;
  const decade = Math.floor(year / 10) * 10;
  return `${decade}s`;
}

export function faceFromSelection(channel: number, selection: SelectionResponse | null): FaceMetadata {
  const item = selection?.item ?? null;
  const year = item?.year ?? null;
  const normalizedGenre = programClassification(item);
  const network = item?.network?.trim() || item?.station?.trim() || "LOCAL";
  const title = item?.title?.trim() || "TUNING IN…";

  return {
    channel,
    title,
    subtitle: item?.subtitle?.trim() || null,
    genre: normalizedGenre.toUpperCase(),
    year: year ? String(year) : "----",
    era: item?.era?.trim() || deriveEra(year),
    network: network.toUpperCase(),
    station: item?.station?.trim() || null,
    item
  };
}

export function readableEra(era: string | null): string {
  if (!era) return "ERA —";
  const normalized = era.toLowerCase().replace(/\s/g, "");
  const match = ERA_LABELS.find((label) => normalized === label.toLowerCase());
  return match ? match.replace("19", "").replace("20", "") : era.toUpperCase();
}

export function formatRuntime(seconds: number | null | undefined): string | null {
  if (!seconds || seconds <= 0) return null;
  const minutes = Math.floor(seconds / 60);
  const remaining = Math.floor(seconds % 60).toString().padStart(2, "0");
  return `${minutes}:${remaining}`;
}

export function programContext(item: SelectionResponse["item"] | null): string {
  if (!item) return "";
  const year = typeof item.year === "number" && Number.isInteger(item.year) && item.year > 0 ? String(item.year) : "";
  const rawGenre = programClassification(item);
  const genre = /^(program|unknown)$/i.test(rawGenre) ? "" : rawGenre.toLowerCase().replace(/\b\w/g, (letter) => letter.toUpperCase());
  return [year, genre].filter(Boolean).join(" · ");
}

function programClassification(item: SelectionResponse["item"] | null): string {
  const options = { sourceCollection: item?.source_collection, sourceProvider: item?.source_provider };
  return normalizeClassification(item?.genre, options)
    ?? normalizeClassification(item?.program_type, options)
    ?? "PROGRAM";
}
